
import { AgGridReact } from "ag-grid-react";
import axios from "axios";
import  {
  useCallback,
  useEffect,
  useRef,
  useState,
} from "react";
import CustomDatePickerDevice from "./CustomDatePickerDevice";
import { Box, Button } from "@mui/material";
import Addstore from "../../components/Addstore/Addstore";

export default function DeviceList() {
  const [storeList, setStoreList] = useState<any[]>([]);
  const [inputRow, setInputRow] = useState<any>();
  const [addStoreDialog, setAddStoreDialog]= useState<any>()

  const gridRef = useRef<any>(null);
  const [colDefs] = useState([
    { field: "store_id", editable: true ,filter: true},
    { field: "player_id", editable: true, filter: true },
    { field: "store_location", editable: true },
    { field: "banner_name", editable: true },
    { field: "installation_date", editable: true, filter: true ,cellEditor:CustomDatePickerDevice ,
  },
    { field: "operation_status", editable: true },
    { field: "device", editable: true },
    { field: "city", editable: true },
    { field: "state", editable: true },
    { field: "experience", editable: true },
    { field: "procurement_status", editable: true },
    { field: "zip_code", editable: true },
    { field: "store_type", editable: true },
    { field: "device_placement_Easels", editable: true },
    { field: "device_position_Easels", editable: true },
    { field: "address1", editable: true },
    { field: "address2", editable: true },
  ]);
  const [defaultColDef] = useState({
  cellStyle: {textAlign: 'left'},
   valueFormatter:(params:any) => isEmptyPinnedCell(params)?createPinnedCellPlaceholder(params):params.value

  });

  const onAddStoreButton= ()=>{
    setAddStoreDialog(true)
  }

  function getStoreData() {
    const data = axios("https://api.virtualvisions.io/stores")
      .then((response) => {
        return response.data;
      })
      .catch((error) => alert(error));
    return data;
  }

  const onBtnExport = useCallback(() => {
    gridRef.current.api.exportDataAsCsv({ fileName: "device_list" });
  }, []);

  const onRemoveSelected = useCallback(() => {
    if (gridRef && gridRef.current) {
      const selectedData = gridRef.current.api.getSelectedRows();
      const res = gridRef.current.api.applyTransaction({
        remove: selectedData,
      });
      console.log(selectedData[0].id);
      if(selectedData[0].id !== undefined){
          axios.delete(`https://api.virtualvisions.io/deleteStores/${selectedData[0].id}`).then(response =>{
            if (response.data === "success") {
              alert("Record Deleted");
            }
          }).catch(error => console.log(error))
      }
    }
  }, []);

  

  useEffect(() => {
  }, [storeList.length]);

  const onRowValueChanged = useCallback((event:any) => {
    let id = event.data.id;
    var data = event.data;
    if(id === undefined){
      axios
      .post("https://api.virtualvisions.io/insertStores", data)
      .then((response) => {
        if (response.data === "success") {
          alert("Record Inserted");
          setInputRow({});
          onGridReady()
        }
      })
      .catch((error) => console.log("Error Occured",error));
    }
    if(id !== undefined){
      axios
      .post("https://api.virtualvisions.io/updateStores", data)
      .then((response) => {
        if (response.data === "success") {
          alert("Record Updated");
        }
      })
      .catch((error) => console.log(error));
    }
  }, []);


  function isEmptyPinnedCell(params:any) {
    return (
      (params.node.rowPinned === 'top' && params.value == null) ||
      (params.node.rowPinned === 'top' && params.value === '')
    );
  }

  function createPinnedCellPlaceholder({ colDef }:any) {
    return colDef.field[0].toUpperCase() + colDef.field.slice(1) + '...';
  }

  const onGridReady = () => {
    getStoreData().then((data) => setStoreList(data)).catch(error => alert(error));
  };
  return (
    <Box sx={{ width: "100%", textAlign: "center" ,marginTop:"24px"}}>
      <Box sx={{ display:"flex",justifyContent:'space-between',paddingRight:"40px",paddingBottom:"10px", paddingLeft:'40px'}}>
        <Box sx={{margin:"5px 5px"}}>
        <Button variant="contained" color="primary" sx={{minWidth:160}} onClick={onAddStoreButton}>
          Add Store
        </Button>
        </Box>
        <Box sx={{display:'flex', flexDirection:'row'}}>
        <div style={{margin:"0px 5px"}}>
        <Button variant="contained" color="secondary" onClick={onRemoveSelected}>
          Remove Selected
        </Button>
        </div>
        <div style={{margin:"0px 5px"}}>
        <Button variant="contained" color="primary" onClick={onBtnExport}>
          Download CSV
        </Button>
        </div>
        </Box>
        
        
      </Box>
      <div
        className="ag-theme-alpine"
        style={{ height: "80vh", width: "95%", margin: "auto" }}
      >
        <AgGridReact
          columnDefs={colDefs}
          // defaultColDef={defaultColDef}
          rowData={storeList}
          animateRows={true}
          ref={gridRef}
          rowSelection={"multiple"}
          onRowValueChanged={onRowValueChanged}
          // pinnedTopRowData={[inputRow]}
          onGridReady={onGridReady}
          editType={"fullRow"}
        ></AgGridReact>
      </div>
      <Addstore open={addStoreDialog} handleClose={()=>setAddStoreDialog(false)} onGridReady={onGridReady}/>
    </Box>
  );
}
